export { default as formatNumber } from './numbers/format-number';
export { default as parseNumber } from './numbers/parse-number';
//# sourceMappingURL=numbers.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-intl/dist/es/numbers.js
// module id = ../../../../@telerik/kendo-intl/dist/es/numbers.js
// module chunks = 3